import { api } from './index';

export enum OnboardingTrackingEvent {
  BUSINESS_STARTED_QUIZ = 'business_started_quiz',
  USER_PAID_MEMBERSHIP = 'user_paid_membership',
  USER_STARTED_QUIZ = 'user_started_quiz',
}

export interface TrackOnboardingEventRequest {
  event: OnboardingTrackingEvent;
}

export const onboardingTrackingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    trackOnboardingEvent: builder.mutation<void, TrackOnboardingEventRequest>({
      query: ({ event }) => ({
        data: { event },
        method: 'POST',
        url: '/onboarding/tracking_events',
      }),
    }),
  }),
});

export const { useTrackOnboardingEventMutation } = onboardingTrackingApi;
